<template>
  <span>
    <OnlineConsultationIcon
      v-if="type === 'telemedicine'"
    ></OnlineConsultationIcon>
    <ClinicIcon v-else-if="type === 'visit'"></ClinicIcon>
    <AmbulanceIcon v-else-if="type === 'house_call'"></AmbulanceIcon>
  </span>
</template>
<script>
import OnlineConsultationIcon from '@/components/Icons/OnlineConsultation'
import ClinicIcon from '@/components/Icons/Clinic'
import AmbulanceIcon from '@/components/Icons/Ambulance'
export default {
  components: {
    OnlineConsultationIcon,
    ClinicIcon,
    AmbulanceIcon
  },
  props: {
    type: {
      type: String,
      required: true
    }
  }
}
</script>
